import {
  Card,
  CardActionArea,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const GAME_CARDS = [
  {
    title: "💣 Random Bomb",
    description: "랜덤 타이밍 알람 폭탄 게임",
    path: "/",
  },
  {
    title: "💥 랜덤 질문 폭탄",
    description: "대화용 질문을 하나씩 랜덤으로 뽑는 게임",
    path: "/question-bomb",
  },
  {
    title: "⚖️ 밸런스 게임",
    description: "둘 중 하나를 고르고 이야기하는 2지선다 게임",
    path: "/balance-game",
  },
  {
    title: "🗣️ 단어로만 설명하기",
    description: "단어만으로 제시어를 설명하고 사용한 단어 수를 세는 게임",
    path: "/word-description",
  },
];

export default function ListPage() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Stack spacing={3} mt={4}>
        <Typography variant="h5" textAlign="center">
          🧩 Other Games
        </Typography>

        {GAME_CARDS.map((game) => (
          <Card key={game.path}>
            <CardActionArea onClick={() => navigate(game.path)}>
              <CardContent>
                <Typography variant="h6">{game.title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {game.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
        <Card>
          <CardActionArea>
            <CardContent>
              <Typography variant="h6">🚧 준비중</Typography>
              <Typography variant="body2" color="text.secondary">
                곧 추가될 기능입니다.
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Stack>
    </Container>
  );
}
